import type { Document, Heading2, Heading3 } from '@contentful/rich-text-types'
import { BLOCKS } from '@contentful/rich-text-types'
import { getHeadText } from '~/utils/contentfulUtils'
import type { TOCItem, TOCStructure } from './TableOfContent'

export const getTocItems = (richText?: Document): TOCStructure | undefined => {
  if (!richText) return undefined

  const result = [] as TOCStructure

  let currentParent: TOCItem | undefined = undefined

  // Paulo: as im moving the way to get the info to use the contenful package instead of the api I have to put bandages to check which one is being got
  const richInfo = richText.content || richText

  richInfo.forEach((item) => {
    if (item.nodeType === BLOCKS.HEADING_2) {
      currentParent = {
        type: 'HEADING_2',
        text: getHeadText(item as Heading2),
        id: item.data.id,
        subItems: [],
      } as TOCItem
      result.push(currentParent)
    } else if (item.nodeType === BLOCKS.HEADING_3 && currentParent) {
      if (currentParent.subItems === undefined) currentParent.subItems = []

      currentParent.subItems.push({
        type: 'HEADING_3',
        text: getHeadText(item as Heading3),
        id: item.data.id,
      } as TOCItem)
    }
  })

  return result
}
